<template>
  <parent>
    <div class="dashboardWrapper d-flex flex-column h-100 w-100">
      <b-row class="align-items-center">
        <b-col
          lg="9"
          cols="12"
          order="2"
          order-md="1"
        >
          <div class="d-flex flex-md-row flex-column bytes-info mb-1">
            <div class="chart-wrapper p-1 d-flex flex-md-row flex-column">
              <span class="font-weight-bold text-secondary mr-1">Averge Job Encoding Duration: </span>
              <span v-if="!fetchingEncodingAnalytics">
                {{
                  encodingAverageAnalytics.averageEncodingJobTime ?
                    ` ${encodingAverageAnalytics.averageEncodingJobTime} minutes`
                    :
                    ' 0 minutes'
                }}
              </span>
              <span
                v-else
                style="min-width: 65px;"
              >
                <b-spinner small />
              </span>
            </div>
            <div class="chart-wrapper mt-1 mt-md-0 ml-md-1 p-1 d-flex flex-md-row flex-column">
              <span class="font-weight-bold text-secondary mr-1">Averge Output Encoding Duration: </span>
              <span v-if="!fetchingEncodingAnalytics">
                {{
                  encodingAverageAnalytics.averageEncodingOutputTime ?
                    ` ${encodingAverageAnalytics.averageEncodingOutputTime} minutes`
                    :
                    ' 0 minutes'
                }}
              </span>
              <span
                v-else
                style="min-width: 65px;"
              >
                <b-spinner small />
              </span>
            </div>
          </div>
        </b-col>
        <b-col
          class="d-flex justify-content-end mb-1 mb-lg-0"
          lg="3"
          order="1"
          order-md="2"
          cols="12"
        >
          <div class="d-flex flex-row align-items-center">
            <custom-select
              id="headerOptions"
              v-model="interval"
              class="mr-1 border-default border"

              :options="intervalOptions"
            />

            <b-button
              variant="bg-primary"
              @click="init"
            >
              Apply
            </b-button>
          </div>
        </b-col>
      </b-row>
      <numbers-widget
        :loading="fetchingProjectAnalytics"
        :data="projectAnalytics"
      />
      <b-row class="mb-1">
        <b-col
          cols="12"
          lg="6"
          class="mb-2 mb-lg-0"
        >
          <encoding-status-widgets
            class="h-100 w-100"
            :widget-key="`
              ${widgetKey}-encodingAnalytics-${lastFetchedIntervalOption ? lastFetchedIntervalOption : 'noInterval'}
              ${(fetchingOutputAnalytics&&fetchingJobAnalytics) ? 'fetching':'fetched'}
            `"
            :jobs="jobAnalyticsFormatted"
            :outputs="outputAnalyticsFormatted"
            :loading-outputs="fetchingOutputAnalytics"
            :loading-jobs="fetchingJobAnalytics"
          />
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
          <quality-average-widgets
            :widget-key="`${widgetKey}-qualityAnalytics-${lastFetchedIntervalOption ? lastFetchedIntervalOption : 'noInterval'}${fetchingQualityAnalytics ? 'fetching':'fetched'}`"
            :data="qualityAnalytics ? qualityAnalytics : []"
            :loading="fetchingQualityAnalytics"
          />
        </b-col>
      </b-row>
    </div>
  </parent>
</template>

<script>
import stringHelpers from '@/mixins/string-helpers'
import EncodingStatusWidgets from './EncodingStatusWidgets.vue'
import NumbersWidget from './NumbersWidget.vue'
import QualityAverageWidgets from './QualityAverageWidgets.vue'

export default {
  name: 'EncoderDashboard',
  components: {
    NumbersWidget,
    EncodingStatusWidgets,
    QualityAverageWidgets,
  },
  mixins: [stringHelpers],
  data() {
    return {
      widgetKey: 0,
      lastFetchedIntervalOption: null,
      interval: 0,
      intervalOptions: [
        { value: 0, text: 'Last Hour' },
        { value: 1, text: 'Today' },
        { value: 2, text: 'Last Day' },
        { value: 3, text: 'Last Week' },
        { value: 4, text: 'Last Month' },
      ],
    }
  },
  computed: {
    jobAnalytics() { return this.$store.state.encoderAnalytics.jobAnalytics },
    fetchingJobAnalytics() { return this.$store.state.encoderAnalytics.fetchingJobAnalytics },
    jobAnalyticsFormatted() { return this.jobAnalytics ? this.objectToChartData(this.jobAnalytics) : [] },
    outputAnalytics() { return this.$store.state.encoderAnalytics.outputAnalytics },
    fetchingOutputAnalytics() { return this.$store.state.encoderAnalytics.fetchingOutputAnalytics },
    outputAnalyticsFormatted() { return this.outputAnalytics ? this.objectToChartData(this.outputAnalytics) : [] },
    fetchingEncodingAnalytics() { return this.$store.state.encoderAnalytics.fetchingEncodingAnalytics },
    encodingAverageAnalytics() { return this.$store.state.encoderAnalytics.encodingAnalytics },
    fetchingProjectAnalytics() { return this.$store.state.encoderAnalytics.fetchingProjectAnalytics },
    projectAnalytics() { return this.$store.state.encoderAnalytics.projectAnalytics },
    fetchingQualityAnalytics() { return this.$store.state.encoderAnalytics.fetchingQualityAnalytics },
    qualityAnalytics() { return this.$store.state.encoderAnalytics.qualityAnalytics },
    qualityAnalyticsFormatted() { return this.qualityAnalytics ? this.objectToChartData(this.qualityAnalytics) : [] },

  },
  created() {
    this.init()
  },
  methods: {
    objectToChartData(options) {
      const keys = Object.keys(options)
      return keys.map(key => ({ name: this.camelCaseToSentence(key), count: options[key] }))
    },
    fetchJobAnalytics() {
      this.$store.dispatch('encoderAnalytics/fetchJobAnalytics', this.interval)
        .catch(error => { this.errorToast(error.response?.data?.errors || 'Something went wrong while fetching job analytics') })
    },
    fetchOutputAnalytics() {
      this.$store.dispatch('encoderAnalytics/fetchOutputAnalytics', this.interval)
        .catch(error => { this.errorToast(error.response?.data?.errors || 'Something went wrong while fetching output analytics') })
    },
    fetchEncodingAnalytics() {
      this.$store.dispatch('encoderAnalytics/fetchEncodingAnalytics', this.interval)
        .catch(error => { this.errorToast(error.response?.data?.errors || 'Something went wrong while fetching encoding analytics') })
    },
    fetchProjectAnalytics() {
      this.$store.dispatch('encoderAnalytics/fetchProjectAnalytics', this.interval)
        .catch(error => { this.errorToast(error.response?.data?.errors || 'Something went wrong while fetching project analytics') })
    },
    fetchQualityAnalytics() {
      this.$store.dispatch('encoderAnalytics/fetchQualityAnalytics', this.interval)
        .catch(error => { this.errorToast(error.response?.data?.errors || 'Something went wrong while fetching quality analytics') })
    },
    init() {
      this.widgetKey += 1
      this.lastFetchedIntervalOption = this.interval
      this.fetchJobAnalytics()
      this.fetchOutputAnalytics()
      this.fetchEncodingAnalytics()
      this.fetchProjectAnalytics()
      this.fetchQualityAnalytics()
    },
  },
}
</script>
<style lang="scss" scoped>
.dashboardWrapper{
  margin: auto;
  max-width: 1920px;
  width: 100%;
  height: 100%;
  .dashboard-analytics{
    width:100%
  }
}
</style>
